"use strict";

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; };

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

function _asyncGeneratorDelegate(inner, awaitWrap) { var iter = {}, waiting = false; function pump(key, value) { waiting = true; value = new Promise(function (resolve) { resolve(inner[key](value)); }); return { done: false, value: awaitWrap(value) }; } ; iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function () { return this; }; iter.next = function (value) { if (waiting) { waiting = false; return value; } return pump("next", value); }; if (typeof inner.throw === "function") { iter.throw = function (value) { if (waiting) { waiting = false; throw value; } return pump("throw", value); }; } if (typeof inner.return === "function") { iter.return = function (value) { if (waiting) { waiting = false; return value; } return pump("return", value); }; } return iter; }

var getFilesAndDirectoriesFromDirectory = require("./getFilesAndDirectoriesFromDirectory.js");
/**
 * Interop between deprecated webkitGetAsEntry and standard getAsFileSystemHandle.
 */


function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null) return entry;
  return {
    // eslint-disable-next-line no-nested-ternary
    kind: entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
    name: entry.name,
    getFile: function getFile() {
      return new Promise(function (resolve, reject) {
        return entry.file(resolve, reject);
      });
    },
    values: function values() {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var directoryReader, entries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the file is a directory.
                directoryReader = entry.createReader();
                _context.next = 3;
                return _awaitAsyncGenerator(new Promise(function (resolve) {
                  getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
                    onSuccess: function onSuccess(dirEntries) {
                      return resolve(dirEntries.map(function (file) {
                        return getAsFileSystemHandleFromEntry(file, logDropError);
                      }));
                    }
                  });
                }));

              case 3:
                entries = _context.sent;
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(entries), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
}

function createPromiseToAddFileOrParseDirectory(_x, _x2) {
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}

function _createPromiseToAddFileOrParseDirectory() {
  _createPromiseToAddFileOrParseDirectory = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry, relativePath) {
    var file, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, handle;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(entry.kind === 'file')) {
              _context2.next = 10;
              break;
            }

            _context2.next = 3;
            return _awaitAsyncGenerator(entry.getFile());

          case 3:
            file = _context2.sent;

            if (!(file !== null)) {
              _context2.next = 8;
              break;
            }

            file.relativePath = relativePath ? "".concat(relativePath, "/").concat(entry.name) : null;
            _context2.next = 8;
            return file;

          case 8:
            _context2.next = 39;
            break;

          case 10:
            if (!(entry.kind === 'directory')) {
              _context2.next = 39;
              break;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 13;
            _iterator = _asyncIterator(entry.values());

          case 15:
            _context2.next = 17;
            return _awaitAsyncGenerator(_iterator.next());

          case 17:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 23;
              break;
            }

            handle = _step.value;
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(handle, "".concat(relativePath, "/").concat(entry.name))), _awaitAsyncGenerator), "t0", 20);

          case 20:
            _iteratorAbruptCompletion = false;
            _context2.next = 15;
            break;

          case 23:
            _context2.next = 29;
            break;

          case 25:
            _context2.prev = 25;
            _context2.t1 = _context2["catch"](13);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 29:
            _context2.prev = 29;
            _context2.prev = 30;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 34;
              break;
            }

            _context2.next = 34;
            return _awaitAsyncGenerator(_iterator.return());

          case 34:
            _context2.prev = 34;

            if (!_didIteratorError) {
              _context2.next = 37;
              break;
            }

            throw _iteratorError;

          case 37:
            return _context2.finish(34);

          case 38:
            return _context2.finish(29);

          case 39:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[13, 25, 29, 39], [30,, 34, 38]]);
  }));
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}

function getFilesFromDataTransfer(_x3, _x4) {
  return _getFilesFromDataTransfer.apply(this, arguments);
}

function _getFilesFromDataTransfer() {
  _getFilesFromDataTransfer = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dataTransfer, logDropError) {
    var entries, _iterator2, _step2, _ref3, lastResortFile, entry;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _awaitAsyncGenerator(Promise.all(Array.from(dataTransfer.items, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
                var _await$item$getAsFile, lastResortFile, entry;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        lastResortFile = item.getAsFile(); // Chromium bug, see https://github.com/transloadit/uppy/issues/3505.

                        _context3.next = 3;
                        return item.getAsFileSystemHandle == null ? void 0 : item.getAsFileSystemHandle();

                      case 3:
                        _context3.t0 = _await$item$getAsFile = _context3.sent;

                        if (!(_context3.t0 != null)) {
                          _context3.next = 8;
                          break;
                        }

                        _context3.t1 = _await$item$getAsFile;
                        _context3.next = 9;
                        break;

                      case 8:
                        _context3.t1 = getAsFileSystemHandleFromEntry(item.webkitGetAsEntry(), logDropError);

                      case 9:
                        entry = _context3.t1;
                        return _context3.abrupt("return", {
                          lastResortFile: lastResortFile,
                          entry: entry
                        });

                      case 11:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x5) {
                return _ref.apply(this, arguments);
              };
            }())));

          case 2:
            entries = _context4.sent;
            _iterator2 = _createForOfIteratorHelper(entries);
            _context4.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context4.next = 25;
              break;
            }

            _ref3 = _step2.value;
            lastResortFile = _ref3.lastResortFile;
            entry = _ref3.entry;

            if (!(entry != null)) {
              _context4.next = 23;
              break;
            }

            _context4.prev = 11;
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(entry, '')), _awaitAsyncGenerator), "t0", 13);

          case 13:
            _context4.next = 23;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t1 = _context4["catch"](11);

            if (!lastResortFile) {
              _context4.next = 22;
              break;
            }

            _context4.next = 20;
            return lastResortFile;

          case 20:
            _context4.next = 23;
            break;

          case 22:
            logDropError(_context4.t1);

          case 23:
            _context4.next = 6;
            break;

          case 25:
            _context4.next = 30;
            break;

          case 27:
            _context4.prev = 27;
            _context4.t2 = _context4["catch"](4);

            _iterator2.e(_context4.t2);

          case 30:
            _context4.prev = 30;

            _iterator2.f();

            return _context4.finish(30);

          case 33:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 27, 30, 33], [11, 15]]);
  }));
  return _getFilesFromDataTransfer.apply(this, arguments);
}

module.exports = getFilesFromDataTransfer;